import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "status"]

  transform(event) {
    const action = event.params.mode
    const input = this.inputTarget
    const originalValue = input.value
    const nextValue = this.applyTransform(originalValue, action)

    input.value = nextValue
    input.focus()
    input.selectionStart = nextValue.length
    input.selectionEnd = nextValue.length
    input.dispatchEvent(new Event("input", { bubbles: true }))
    this.setStatus(this.statusFor(action, originalValue, nextValue))
  }

  async copy() {
    try {
      await this.writeText(this.inputTarget.value)
      this.setStatus("入力をコピーしました")
    } catch (_error) {
      this.setStatus("コピーできませんでした")
    }
  }

  clear() {
    const input = this.inputTarget

    input.value = ""
    input.focus()
    input.dispatchEvent(new Event("input", { bubbles: true }))
    this.setStatus("入力をクリアしました")
  }

  applyTransform(value, action) {
    switch (action) {
      case "remove_spaces":
        return value.replace(/\s+/g, "")
      case "letters_only":
        return value.replace(/[^A-Za-z]/g, "")
      case "numbers_only":
        return value.replace(/\D/g, "")
      case "reverse":
        return Array.from(value).reverse().join("")
      case "uppercase":
        return value.toUpperCase()
      case "lowercase":
        return value.toLowerCase()
      default:
        return value
    }
  }

  statusFor(action, originalValue, nextValue) {
    if (originalValue === nextValue) {
      return "入力は変わりませんでした"
    }

    return {
      remove_spaces: "空白を削除しました",
      letters_only: "英字だけ残しました",
      numbers_only: "数字だけ残しました",
      reverse: "逆順にしました",
      uppercase: "大文字にしました",
      lowercase: "小文字にしました"
    }[action] || "入力を整えました"
  }

  async writeText(text) {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text)
    } else {
      this.copyWithFallback(text)
    }
  }

  copyWithFallback(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }

  setStatus(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
    }
  }
}
